import { SITE } from "@/data/site";
import {
  COLUMNS,
  FooterBrand,
  FooterColumn,
  FooterWordmark,
} from "@/components/footer/FooterParts";

export default function SiteFooter() {
  return (
    <footer
      data-testid="footer-section"
      className="relative z-10 overflow-hidden border-t border-white/10 bg-[#0B0C10]/80 px-6 pt-24 backdrop-blur-md md:px-16 lg:px-24"
    >
      <div className="grid gap-14 lg:grid-cols-[1.4fr_1fr_1fr] lg:gap-20">
        <FooterBrand />
        {COLUMNS.map((column) => (
          <FooterColumn key={column.heading} column={column} />
        ))}
      </div>

      <div className="relative mt-20 flex flex-wrap items-center justify-between gap-6 border-t border-white/10 py-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#F4F6FB]/40">
          © 2026 Elentara — All Rights Reserved
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#F4F6FB]/30">
          {SITE.philosophy}
        </p>
      </div>

      <FooterWordmark />
    </footer>
  );
}
